<div class="flex-1 d-flex fd-col ai-stretch">
  <h4 class="header-top-margin">{{ option.filterMethodConfig?.title || 'Between Dates' }}</h4>
  <div
    class="list-container flex-1 d-flex fd-row flex-wrap gap-8"
  >
    <p class="item-checkbox basis-18" *ngFor="let item of checkboxItems; let i = index">
      <mat-checkbox [checked]="item.checked" (change)="itemChecked($event, item)" color="primary"
        >{{ item.name }}
      </mat-checkbox>
    </p>
  </div>
</div>
